import { CHART_NAME } from '../../../../utils/constants.js';
import {
   DAILY_WEEKLY_TOGGLE_TAB,
   DASHBOARD_GRAPH_X_AXIS_KEY,
   getPlotBarsConfigByRecommStatus,
   getXAxisTickFormatter,
} from '../charts-util.js';

export const getStructuralChartConfig = (
   recommendationStatus,
   filteredStructuralSummaryData,
   dailyWeeklyTabValue,
   handleBarOnClick,
   handleDailyWeeklyTabOnClick
) => {
   return {
      chartKey: `${CHART_NAME.CHART_STRUCTURAL}-${recommendationStatus}`,
      chartTitle: CHART_NAME.CHART_STRUCTURAL,
      configBars: {
         plotBars: getPlotBarsConfigByRecommStatus(
            recommendationStatus,
            filteredStructuralSummaryData
         ),
         isHighLightBarOnClick: true,
         isHighLightCellOnClick: false,
         isStackedBars: true,
         barSize: 20,
         isSetBarBackground: false,
         barOnClickHandler: handleBarOnClick,
      },
      configXAxis: {
         xAxisKey: DASHBOARD_GRAPH_X_AXIS_KEY,
         xAxisTickFormatter: (tick) =>
            getXAxisTickFormatter(tick, dailyWeeklyTabValue),
      },
      configYAxis: {
         yAxisTickFormatter: (tick) => tick,
      },
      configToggle: {
         toggleName: `day-week-view-${CHART_NAME.CHART_STRUCTURAL}`,
         selectedValue: dailyWeeklyTabValue,
         toggle: [
            {
               toggleLabel: 'D',
               toggleValue: DAILY_WEEKLY_TOGGLE_TAB.DAILY,
               className: 'col-xs-2 col-sm-1',
            },
            {
               toggleLabel: 'W',
               toggleValue: DAILY_WEEKLY_TOGGLE_TAB.WEEKLY,
               className: 'col-xs-2 col-sm-1',
            },
         ],
         toggleTabOnClickHandler: handleDailyWeeklyTabOnClick,
      },
      configLegends: {
         isToggleChartOnClickOfLegend: true,
      },
      isVisibleHorizontalGrid: true,
   };
};
